import React, { useId, useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
}
export function FaqItem({
  question,
  answer
}: FaqItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return <div className="border-b border-brand-charcoal/12" data-id="element-15" data-mp="1r0lb8xbzrk6y">
      <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setIsOpen(current => !current)} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-200 ease-out hover:text-brand-charcoal/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-charcoal/40" data-id="element-16" data-mp="1qz0fj4dxxv7i">
        <span className="font-body text-[15px] font-medium leading-snug text-brand-charcoal sm:text-base" data-id="element-17" data-mp="181qs7c5hvxkz">
          {question}
        </span>
        <span aria-hidden="true" className="flex-none text-brand-charcoal/50" data-id="element-18" data-mp="2xhgidpmhkg4f">
          {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-19" data-mp="32ep2vwv3ww8u" /> : <PlusIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-20" data-mp="102e9vm0twq0x" />}
        </span>
      </button>
      {isOpen && <p id={panelId} className="max-w-2xl pb-6 pr-8 text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-21" data-mp="v3b3ny944drd">
          {answer}
        </p>}
    </div>;
}